/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your practice conversations…" |
*
* @param {Practice_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_loading = /** @type {((inputs?: Practice_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je oefengesprekken worden geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de vos entretiens d'entraînement…")
	return /** @type {LocalizedString} */ ("Loading your practice conversations…")
});